// extracted by mini-css-extract-plugin
export var closed = "_h2-1";
export var resizer = "_h2-0";